import { EventKeyValues } from '@routable/shared';
import { useCallback, useEffect } from 'react';
export const useEnterKeyToEmulateTab = (inputRef) => {
    const onCallback = useCallback((event) => {
        if (event.key !== EventKeyValues.ENTER || event.shiftKey) {
            return;
        }
        const form = event?.target?.form;
        if (!form) {
            return;
        }
        const formInputs = Array.from(form.elements);
        const nextInputIndex = formInputs.indexOf(event?.target) + 1;
        if (nextInputIndex > formInputs.length) {
            return;
        }
        formInputs[nextInputIndex].focus();
        event.preventDefault();
    }, []);
    useEffect(() => {
        const input = inputRef.current;
        if (inputRef.current) {
            input.addEventListener('keypress', onCallback);
        }
        return () => {
            if (input) {
                input.removeEventListener('keypress', onCallback);
            }
        };
    }, [inputRef, onCallback]);
};
